import { render, staticRenderFns } from "./EmailGroupModal.vue?vue&type=template&id=3651648d&scoped=true"
import script from "./EmailGroupModal.vue?vue&type=script&lang=js"
export * from "./EmailGroupModal.vue?vue&type=script&lang=js"
import style0 from "./EmailGroupModal.vue?vue&type=style&index=0&id=3651648d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3651648d",
  null
  
)

export default component.exports